import React, { useState, useEffect } from "react";
import { Table, Modal, Button, Input, notification } from "antd";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { baseApiUrl } from "../../services/api";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';


import axios from "axios";
import { Link } from "react-router-dom";


const Newsletter = () => {
  const [subscribers, setSubscribers] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [subscribed, setSubscribed] = useState(true);
  const [confirmed, setConfirmed] = useState(true);
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // useEffect(() => {
  //   axios
  //     .get("http://localhost:8081/api/plateforme/newsletter/subscribers", {
  //       headers: { accept: "*/*" },
  //     })
  //     .then((response) => {
  //       setSubscribers(response.data);
  //     })
  //     .catch((error) => {
  //       console.error("Erreur lors de la récupération des abonnés:", error);
  //       notification.error({
  //         message: "Erreur",
  //         description: "Impossible de récupérer les abonnés à la newsletter.",
  //       });
  //     });
  // }, []);

  useEffect(() => {

    const fetchNews = async () => {
      try {
        const response = await baseApiUrl.get(
          "/newsletter/subscribers"
        );
        console.log("users recuperé:", response);

        setSubscribers(response.data);

      } catch (error) {
        console.error("Erreur lors du chargement des abonné", error);
      }
    };

    fetchNews();
  }, []);


  const filteredSubscribers = subscribers.filter(
    (subscriber) =>
      subscriber.email.toLowerCase().includes(searchText.toLowerCase())
  );

  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log("Form submitted"); // Vérifier si le formulaire est bien soumis
    // setIsLoading(true);
    setErrorMessage('');
    setSuccessMessage('');

    try {
      console.log("Sending request...");
      const response = await baseApiUrl.post(
        `/newsletter/subscribe?email=${encodeURIComponent(email)}`,
        {
          subscribed: true,
          confirmed: true
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      console.log("Response received:", response);
      if (response.status === 200) {
        setSuccessMessage("Your subscription request has been sent. Thank you!");
      } else {
        setErrorMessage("An error occurred. Please try again.");
      }
    } catch (error) {
      console.log("Error caught:", error);
      if (error.response) {
        console.log("Erreur de réponse:", error.response.data);
        setErrorMessage(error.response.data.message || "An error occurred. Please try again.");
      } else if (error.request) {
        console.log("Erreur de requête:", error.request);
        setErrorMessage("No response from the server. Please try again later.");
      } else {
        console.log("Erreur inconnue:", error.message);
        setErrorMessage("An unknown error occurred.");
      }
    } finally {
      setIsLoading(false);
    }
  };


  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Abonné",
      dataIndex: "subscribed",
      key: "subscribed",
      render: (text) => (text ? "Oui" : "Non"),
    },
    {
      title: "Confirmé",
      dataIndex: "confirmed",
      key: "confirmed",
      render: (text) => (text ? "Oui" : "Non"),
    },
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-7 col-auto">
                <h3 className="page-title">Abonnés à la newsletter</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Newletters</li>
                </ul>
              </div>
              <div className="top-nav-search">
                <form>

                  <input
                    className="form-control"
                    placeholder="Rechercher "
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                  <button className="btn" type="submit">
                    <i className="fa fa-search" />
                  </button>
                </form>
              </div>
              <div className="col-sm-5 col">
                <button
                type="success"
                  className="float-end mt-2 btn-success"
                  onClick={() => setIsModalVisible(true)}
                >
                  <FontAwesomeIcon icon={faPlus} className="me-2" /> {/* Icône ajoutée ici */}
                  Ajouter un abonné
                </button>
              </div>
            </div>
          </div>


          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="table-responsive">
                    <Table
                      columns={columns}
                      dataSource={filteredSubscribers}
                      rowKey={(record) => record.id}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        title="Ajouter un abonné"
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
      >
        <form onSubmit={handleSubmit}>
          <div className="row form-row">
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            {/* <div className="form-group">
            <label>Abonné</label>
            <select
              className="form-control"
              value={subscribed}
              onChange={(e) => setSubscribed(e.target.value === "true")}
            >
              <option value="true">Oui</option>
              <option value="false">Non</option>
            </select>
          </div>
          <div className="form-group">
            <label>Confirmé</label>
            <select
              className="form-control"
              value={confirmed}
              onChange={(e) => setConfirmed(e.target.value === "true")}
            >
              <option value="true">Oui</option>
              <option value="false">Non</option>
            </select>
          </div> */}
            <button type="submit" className="btn btn-primary w-100 mt-3">
              Ajouter
            </button>
          </div>
        </form>
        {isLoading && <div className="loading">Loading</div>}
        {errorMessage && <div className="error-message">{errorMessage}</div>}
        {successMessage && <div className="sent-message">{successMessage}</div>}
      </Modal>
    </>
  );
};

export default Newsletter;
